import { Dispatch, FC, SetStateAction } from "react";
import { ChevronUpButton } from "shared/components/buttons/ChevronButton";
import { PlusButton } from "shared/components/buttons/PlusButton";
import { Flex, Text } from "shared/components/Spor";
import { NoteOutline24Icon } from "shared/icons/NoteIcon";

type FormTextareaHeaderProps = {
  label: string;
  isEdited: boolean;
  active: boolean;
  setActive: Dispatch<SetStateAction<boolean>>;
};

export const FormTextareaHeader: FC<FormTextareaHeaderProps> = ({
  label,
  isEdited,
  active,
  setActive,
}) => (
  <Flex alignItems="center" justifyContent="space-between" w="100%">
    <Flex gap="6px">
      <NoteOutline24Icon />
      <Text fontWeight="900">{label}</Text>
    </Flex>
    {isEdited ? (
      <ChevronUpButton active={active} setActive={setActive} />
    ) : (
      <PlusButton active={active} setActive={setActive} />
    )}
  </Flex>
);
